// extracted by mini-css-extract-plugin
module.exports = {"toggleButtonContainer":"toggle-button_toggleButtonContainer__2bkOl","labelContainer":"toggle-button_labelContainer__2fo8S"};